import PrivilegesUpload from "./privileges-upload";

export default PrivilegesUpload;
